/**
 * Created by lari on 03/05/2017.
 */
/* either pass list of drugs (patdrugss) to dispay or load drugs/patdrugss depending on mode */


(function () {
  'use strict';
  angular.module('vcdrug')
    .component('drugprescription', {
      restrict: 'E',
      bindings: {
        patientid: '<'
      },
      templateUrl: 'vcdrug/drugprescription-smartcomponent.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Rlog', 'Drug', 'Med', 'Config', 'vertxEventBusService', '$element', 'lodash', '$sce', '$window', '$timeout',
        function ($log, Rlog, Drug, Med, Config, vertxEventBusService, $element, _, $sce, $window, $timeout) {
          let vm = this;
          vm.ready = 'loading';
          vm.data = null;
          vm.getDrugs = getDrugs;
          vm.showdruginfo = showdruginfo;
          vm.addDrug = addDrug;
          vm.replaceDrug = replaceDrug;

          // popover templates
          vm.drugalternativestpl = 'drugalternativestpl.html';
          vm.repopovertpl = 'repopovertpl.html';
          vm.pppopovertpl = 'pppopovertpl.html';
          vm.indpopovertpl = 'indpopovertpl.html';
          vm.hintpopovertpl = 'hintpopovertpl.html';
          vm.kzpopover = 'kzpopover.html';
          vm.atcalternativestpl = 'atcalternativestpl.html';


          vm.$onInit = function () {
            Config.$find('drugconfig').$then(function (sigs) {
              //  vm.conf.drugsignature.length
              vm.conf = sigs;
              // intialize if still empty
              if (!angular.isArray(vm.conf.drugsignature)) {
                vm.drugsignature.drugsignature = [];
              }
              if (!angular.isString(vm.conf._id)) {
                vm.drugsignature._id = 'drugconfig';
              }
            });
          };

          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue) && changes.patientid.currentValue.length > 0) {
              vm.patientid = changes.patientid.currentValue;
              Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
                $log.info('drugs found: ', drugs);
                vm.patdrugs = drugs[0];
                vm.ready = true;
              });
            }
          };


          // drugahead drug name completion
          function getDrugs(val) {
            console.log('loading drug names');
            vm.newdrug = {};
            return Med.$searchahead({query: val}).$asPromise().then(function (response) {
              // console.log('drug search response: ', response);
              return response.map(function (drug) {
                if (angular.isString(drug.amount) && angular.isString(drug.amounttype)) {
                  drug.text = drug.name + ' (' + drug.amount + drug.amounttype + ')';
                } else {
                  drug.text = drug.ZBEZ + ' (' + drug.ZLNUMM + ')';
                }
                return drug;
              });
            });
          }

          // typeahead drug search information
          function showdruginfo($item) {
            /* jshint unused:false */
            /* eslint "no-unused-vars": [0, {"args": "none"}] */
            let atcquery;
            let atcar = [];

            vm.newdrug = {};

            $log.debug('showdruginfo called: ', $item);
            vm.selectedDrug = $item;

            if (angular.isString(vm.selectedDrug.name)) {
              vm.newdrug.name = vm.selectedDrug.name;
            } else {
              vm.newdrug.name = vm.selectedDrug.ZBEZ;
            }
            vm.newdrug.op = 'OP I';
            vm.newdrug.permanent = true;


            // Suchtgiftvignette
            if (vm.selectedDrug.ZSUCHT === 'SG') {
              vm.newdrug.vignette = true;
              vm.newdrug.comment = 'Suchtgiftvignette! Mengenangaben aussschreiben!';
            }

            // SV Box system
            if (angular.isString(vm.selectedDrug.box)) {
              vm.newdrug.box = vm.selectedDrug.box;
            } else {

              if (vm.selectedDrug.atcarray.length === 1) {
                atcquery = {atcarray: vm.selectedDrug.atcarray[0]};
              } else {
                vm.selectedDrug.atcarray.forEach(function (a) {
                  atcar.push({atcarray: a});
                });
                atcquery = {$or: atcar};
                // var foo = {$or: [{columnA: 3}, {columnB: 'string'}]};
              }

              vm.newdrug.atcalternatives = Drug.$search(atcquery);
            }


            // Pharmanr
            if (angular.isString(vm.selectedDrug.pharmanr)) {
              vm.newdrug.pharmanr = vm.selectedDrug.pharmanr;
            }

            // Zulassungsnummer
            if (angular.isString(vm.selectedDrug.ZLNUMM)) {
              vm.newdrug.ZLNUMM = vm.selectedDrug.ZLNUMM;
            }

            // Array aller ATC codes
            if (angular.isArray(vm.selectedDrug.atcarray)) {
              vm.newdrug.atcarray = vm.selectedDrug.atcarray;
            }

            // Fachinformationen
            if (angular.isString(vm.selectedDrug.fi)) {
              // "fi" : "/fi_pdf/1-21520.pdf"
              // "fi" : "/eu_pdf/1-21520.pdf"
              vm.newdrug.fi = vm.selectedDrug.fi.replace(/_/g, '');
              vm.newdrug.fi = vm.newdrug.fi.replace(/\.pdf/g, '');
            }

            // Postion im SV ekotool preivergleich
            if (angular.isString(vm.selectedDrug.position)) {
              vm.newdrug.svpos = parseInt(vm.selectedDrug.position, 10);
            }

            // packungsgröße/art
            if (angular.isString(vm.selectedDrug.amount) && angular.isString(vm.selectedDrug.amounttype)) {
              vm.newdrug.pkgsize = vm.selectedDrug.amount + ' ' + vm.selectedDrug.amounttype;
            }

            if (angular.isString(vm.selectedDrug.amount) && !angular.isString(vm.selectedDrug.amounttype)) {
              vm.newdrug.pkgsize = vm.selectedDrug.amount;
            }

            // if (angular.isString()) {}

            // Hinweis zum Medikament
            if (vm.selectedDrug.hint) {
              vm.newdrug.hint = $sce.trustAsHtml('<div>' + vm.selectedDrug.hint + '</div>');  // overlay html must be contained in single tag
            }

            // kassenzeichen
            // KZ RE1 RE2
            if (vm.selectedDrug.kz === 'RE1' || vm.selectedDrug.kz === 'RE2') {
              vm.newdrug.re = vm.selectedDrug.kz;
            }
            if (vm.selectedDrug.recriteria) {
              $log.debug('recriteria: ', vm.selectedDrug.recriteria);
              vm.newdrug.recriteria = $sce.trustAsHtml('<div>' + vm.selectedDrug.recriteria + '</div>');  // overlay html must be contained in single tag
            }

            // KZ IND
            if (vm.selectedDrug.kz && vm.selectedDrug.kz === 'IND') {
              vm.newdrug.ind = true;
            }

            if (vm.selectedDrug.indcriteria) {
              vm.newdrug.indcriteria = $sce.trustAsHtml('<div>' + vm.selectedDrug.indcriteria + '</div>');
            }


            // All other KZ entries, use popover lookup table
            if (vm.selectedDrug.kz !== '' && vm.selectedDrug.kz !== 'RE1' &&
              vm.selectedDrug.kz !== 'RE2' && vm.selectedDrug.kz !== 'IND') {
              vm.newdrug.kz = vm.selectedDrug.kz;
            }

            // Langzeitbewilligung
            if (vm.selectedDrug.permpermit !== '') {
              vm.newdrug.permpermit = vm.selectedDrug.permpermit;
            }

            // alternatives
            vm.newdrug.alternatives = [];
            if (angular.isArray(vm.selectedDrug.alternatives)) {
              vm.newdrug.alternatives = [];
              // reorder by price/posnr
              // sv data format is crap - alternatives are not sorted by proce/posnr
              // more than one drug can occupy the same posnr
              // at least they had the decency to leave space for ex-aequo drugs
              // if more than 3 products tie, I simply don't care, third place gets overridden
              for (let i = 0; i < vm.selectedDrug.alternatives.length; i++) {
                if (vm.selectedDrug.alternatives[i].posnr < vm.newdrug.svpos) {
                  switch (vm.selectedDrug.alternatives[i].comparetype) {
                    case '1':
                      vm.selectedDrug.alternatives[i].color = 'success';
                      vm.selectedDrug.alternatives[i].tooltip = 'Alternative mit gleichem Wirkstoff und gleicher Stärke';
                      break;
                    case '2':
                      vm.selectedDrug.alternatives[i].color = 'warning';
                      vm.selectedDrug.alternatives[i].tooltip = 'Biosimilar, Alternative mit gleichem Wirkstoff und ähnlicher Stärke';
                      break;
                    case '3':
                      vm.selectedDrug.alternatives[i].color = 'error';
                      vm.selectedDrug.alternatives[i].tooltip = 'Alternative mit anderem Wirkstoff';
                      break;
                    default:
                      break;
                  }
                } else {
                  vm.selectedDrug.alternatives[i].color = 'default';
                  vm.selectedDrug.alternatives[i].tooltip = 'Alternative ist nicht günstiger als das gewählte Produkt';
                }
                if (!vm.newdrug.alternatives[vm.selectedDrug.alternatives[i].posnr - 1]) {
                  vm.newdrug.alternatives[vm.selectedDrug.alternatives[i].posnr - 1] = vm.selectedDrug.alternatives[i];
                } else {
                  if (!vm.newdrug.alternatives[vm.selectedDrug.alternatives[i].posnr]) {
                    vm.newdrug.alternatives[vm.selectedDrug.alternatives[i].posnr] = vm.selectedDrug.alternatives[i];
                  } else {
                    if (!vm.newdrug.alternatives[vm.selectedDrug.alternatives[i].posnr + 1]) {
                      vm.newdrug.alternatives[vm.selectedDrug.alternatives[i].posnr + 1] = vm.selectedDrug.alternatives[i];
                    } else {
                      vm.newdrug.alternatives[vm.selectedDrug.alternatives[i].posnr + 2] = vm.selectedDrug.alternatives[i];
                    }
                  }
                }
              }

              // type 3: Anderer Wirkstoff
              for (let i = 0; i < vm.newdrug.svpos; i++) {
                if (vm.newdrug.alternatives[i].comparetype === '3') {
                  vm.newdrug.alttype = 'danger';
                  vm.newdrug.alttypetext = 'Alternativen mit anderen Wirkstoffen sind günstiger';
                }
              }

              // type 2: Gleicher Wirkstoff, andere Dosis, Biosimilars
              for (let i = 0; i < vm.newdrug.svpos; i++) {
                if (vm.newdrug.alternatives[i].comparetype === '2') {
                  vm.newdrug.alttype = 'warning';
                  vm.newdrug.alttypetext = 'Alternativen mit Biosimilars (gleicher Wirkstoff, ähnliche Stärke) sind günstiger';
                }
              }

              // type 1: Gleicher Wirkstoff, gleiche Stärke
              for (let i = 0; i < vm.newdrug.svpos; i++) {
                if (vm.newdrug.alternatives[i].comparetype === '1') {
                  vm.newdrug.alttype = 'success';
                  vm.newdrug.alttypetext = 'Alternativen mit gleichem Wirkstoff und gleicher Stärke sind günstiger';
                }
              }

              // if med was already in first position, greyout alternatives option
              if (vm.newdrug.svpos === 1) {
                vm.newdrug.alttype = 'default';
                vm.newdrug.alttypetext = 'Dieses Medikament ist das günstigste mit diesem Wirkstoff und dieser Stärke';
              }

              $log.debug('selected drug: ', vm.selectedDrug);
              $log.debug('new drug: ', vm.newdrug);
            } // rebuild alternatives
          }


          function replaceDrug(replacement) {
//          $log.debug('replacement: ', replacement.pharmanr);
            Med.$searchpharma({pharmanr: replacement.pharmanr}).$asPromise().then(function (rdrug) {
              vm.newdrug = {};
              vm.showdruginfo(rdrug[0]);
              if (rdrug.length > 1) {
                $log.error('Pharmanr search returned more than one result');
              }
            });
          }

          function addDrug() {
            delete vm.noResults;
            vm.newdrug.color = 'primary';
            vm.newdrug.foreign = false;
            vm.newdrug.active = true;
            vm.newdrug.startDate = moment().toISOString();
            vm.newdrug.print = true;
            if (!vm.newdrug.permanent) {
              vm.newdrug.endDate = moment().add(14, 'days').toISOString();
            }
            vm.patdrugs.drugs.push(vm.newdrug);
            // calculateActivedrugs();
            vm.patdrugs.$save();
            vm.selectedDrug = {};
            vm.newdrug = {};
            vm.newdrug.op = 'OP I';
            vm.asyncSelected = '';
          }


          // sprhelp texte
          vm.sprgen = ``;
          vm.sprsearch = `Bitte geben Sie mindestens drei Buchstaben ein, um Medikamentenvorschläge zu erhalten.
            Medikamente die sich in der Green Box oder Yellow Box des Erstattungscodex befinden, werden nach
            Packungsgröße getrennt angezeigt. Günstigere Alternativen werden nach auswahl eines Medikaments rechts
            bzw. unterhalb nach Preis gestaffelt angezeigt. Sie können Nahrungsergänzungsmittel, Tees, udgl.
            durch Ausschreiben des Prodktnames verordnen. Den Hinweis, dass kein entsprechendes Medikament gefunden wurde,
            ignorieren Sie in diesem Fall einfach.`;

          vm.sprsignature = `W&auml;hlen Sie aus der Liste oder geben Sie eine andere Anweisung ein.
            Sie k&ouml;nnen die Auswahlliste im Einstellungsmenu unter Einstellungen &auml;ndern.`;
          vm.sprpkgsize = `Die Packungsgr&ouml;&szlig;e wird bei Medikamenten, die von der Krankenkasse erstattet werden,
            automatisch ausfeg&uuml;ellt.`;
          vm.sprpkgnr = `Wenn f&uuml;r langzeitbewilligbare Medikamente mehr als drei Packungen erforderlich sind,
            vermerken Sie das bitte unter dem L\'x\' Hinweis im Rezeptvermerk.`;
          vm.sprduration = `Anla&szlig;bezogene Medikation (z.B. Antibiotika) wird 14 Tage nach der Verschreibung automatisch deaktiviert
             und ist danach nur noch in der Medikationshistorie ersichtlich.
             Dauermedikation (z.B. Beta-Blocker) verbleibt in der Medikamentenliste des Patienten bis Sie es manuell absetzen.`;
          vm.sprcomment = `Im Falle einer Suchgiftverschreibung ergänzen Sie bitte Packungszanzahl und Dosierung in Worten:
             z.B. zweihundert Milligramm, eine Packung. Bei Suchtgiften für den eigenen Gebrauch ergänzen
             Sie bitte "pro ordinatione" oder "für N.N.".`;
          vm.sprind = `Verschreibungen die bestimmten Indikationen unterleigen wir der Vermerk "IND" automatisch angebracht.
             Es empfiehlt sich zusätzlich die jeweilige Indikation im Rezeptvermerk anzuführen.
             Die zulässigen Indikationen entnehmen Sie bitte der obigen "IND" Schaltfläche`;



          const configUpdateHandler =function (message) {
            $log.debug('******** config update received: ', message);
            let messages = message.split(':');

            if (angular.isDefined(vm.conf)) {
              if (messages[0] === 'drugsignature') {
                vm.conf.$refresh().$then(function () {
                  $log.debug('******* config refresh drugsignatures');
                }, function (error) {
                  $log.debug('******* config refresh drugsignatures failed: ', error);
                });
              }
            }
          };

          const patdrugsUpdateHandler = function (message) {
            // $log.debug('debug: Client update received: ', message);
            let messages = message.split(':');
            if (angular.isDefined(vm.patdrugs) && angular.isDefined(vm.patdrugs._id) && vm.patdrugs._id === messages[0]) {
              vm.patdrugs.$refresh().$then(function (drugs) {
                $log.debug('refreshed patdrugs for drugprescription: ', vm.patdrugsid);
                // only show vm. drug_saved when change was triggered by this browser
                if (messages[1] === $window.sessionStorage.getItem('sprtabid')) {
                  vm.drug_saved = true;
                  $timeout(function () {
                    delete vm.drug_saved;
                  }, 3000);
                  $log.debug('(drugprescription) drug saved');
                }
              }, function (error) {
                $log.debug('refreshing patdrugs drugprescription failed: ', error, vm.patdrugsid);
              });
            }
          };

          // update dugsignature list TODO: doesnt work, needs backend update message
          vertxEventBusService.on('config.update', {}, configUpdateHandler);

          // update patientdrugs
          vertxEventBusService.on('patdrugs.update', {}, patdrugsUpdateHandler);

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('patdrugs.update', {}, patdrugsUpdateHandler);
            vertxEventBusService.unregisterHandler('config.update', {}, configUpdateHandler);
          };

        }] // controller
    }); // component

  // klammerfriedhof
}());
